import * as Yup from "yup";

export function initialValues(academicCycle) {
  return {
    levelId: academicCycle?.levelId || "",
    name: academicCycle?.name || "",
    startDate: academicCycle?.startDate || false,
    endDate: academicCycle?.endDate || false,
    syllabuId: academicCycle?.syllabuId || "",
    pedagogicalHour: academicCycle?.pedagogicalHour || 45,
    shiftStart: academicCycle?.shiftStart?.substring(0, 5) || "08:00",
    shiftEnd: academicCycle?.shiftEnd?.substring(0, 5) || "15:40",
    recessStart: academicCycle?.recessStart?.substring(0, 5) || "10:30",
    recessEnd: academicCycle?.recessEnd?.substring(0, 5) || "10:45",
    periodType: academicCycle?.periodType || "",
  };
}

export function validationSchema() {
  return Yup.object({
    levelId: Yup.number().required("El nivel es obligatorio"),
    name: Yup.string().required("El nombre es obligatorio"),
    syllabuId: Yup.string().required("La malla curricular es obligatoria"),
    startDate: Yup.date()
      .required("La fecha de inicio es obligatoria")
      .typeError("La fecha de inicio debe ser una fecha válida"),
    endDate: Yup.date()
      .required("La fecha de fin es obligatoria")
      .typeError("La fecha de fin debe ser una fecha válida"),
    periodType: Yup.string()
      .required("El tipo de período es obligatorio")
      .oneOf(["bimestre", "trimestre"], "Debe seleccionar un tipo de período válido"),
    pedagogicalHour: Yup.number()
      .min(1, "Debe ser al menos 1 minuto")
      .required("La hora pedagógica es obligatoria"),
    shiftStart: Yup.string()
      .matches(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/, "Formato de hora inválido (HH:MM)")
      .required("El inicio de turno es obligatorio"),
    shiftEnd: Yup.string()
      .matches(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/, "Formato de hora inválido (HH:MM)")
      .required("El fin de turno es obligatorio")
      .test("shift-end-after-start", "El fin de turno debe ser posterior al inicio", function(value) {
        const { shiftStart } = this.parent;
        if (!shiftStart || !value) return true;
        return value > shiftStart;
      }),
    recessStart: Yup.string()
      .matches(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/, "Formato de hora inválido (HH:MM)")
      .required("El inicio de receso es obligatorio")
      .test("recess-start-after-shift-start", "El receso debe iniciar después del turno", function(value) {
        const { shiftStart } = this.parent;
        if (!shiftStart || !value) return true;
        return value > shiftStart;
      }),
    recessEnd: Yup.string()
      .matches(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/, "Formato de hora inválido (HH:MM)")
      .required("El fin de receso es obligatorio")
      .test("recess-end-after-recess-start", "El fin de receso debe ser posterior al inicio", function(value) {
        const { recessStart } = this.parent;
        if (!recessStart || !value) return true;
        return value > recessStart;
      })
      .test("recess-end-before-shift-end", "El receso debe terminar antes de fin del turno", function(value) {
        const { shiftEnd } = this.parent;
        if (!shiftEnd || !value) return true;
        return value < shiftEnd;
      }),
  });
}
